// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--EsXr1 col-xs-offset-2 col-xs-9","cover":"cover--XBIWx","tabs":"tabs--QENYg","drop":"drop--YAShQ"};